import styled from "styled-components";

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 26px;
	margin-bottom: 10px;
`;
